// extracted by css-extract-rspack-plugin
export default {"payload":"IIJnTb7nydA4lOZG","code":"wVFiatCl8PsIg6ho","codeCollapsed":"MzNlAeCVtPcSJXBN","toggle":"ooPs8eFJE460yVIQ"};